<template>
  <div>
    <div class="header other-banner other-banner-about" id="">
      <div class="container">
        <div class="other-banner-title">{{$t('about.AboutUs')}}</div>
      </div>
    </div>
    <!--content-->
    <div class="content bgf5f5f5">
      <div>&nbsp;</div>
      <div class="container sub-nav about-nav">
        <div class="col-md-12">
          <router-link to="about">{{$t('about.CompanyInformation')}}</router-link>
          <router-link to="aboutRecruitment">{{$t('about.CareerOpportunities')}}</router-link>
          <router-link to="aboutContact">{{$t('about.ContactUs')}}</router-link>
          <router-link to="aboutIntegrity">{{ $t('clause.compliance') }}</router-link>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
    export default {
        name: "about"
    }
</script>

<style scoped>
  .router-link-active{
    background: #ee7532;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// about.vue?4df4dceb